import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const PageSizeSelector = ({ pageSize, onPageSizeChange }) => {
    const { t } = useTranslation();
    return (
        <Form.Group as={Row} className="align-items-center">
            <Form.Label column sm="auto" className="mb-0">{t('pageSizeSelector.label')}</Form.Label>
            <Col sm="auto">
                <Form.Select value={pageSize} onChange={onPageSizeChange} style={{ width: 'auto' }}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                </Form.Select>
            </Col>
        </Form.Group>
    );
};

export default PageSizeSelector;
